import { DotsThree, Info } from '@phosphor-icons/react';
import { Button, Dropdown, Tooltip } from 'antd';
import { useCallback, useMemo } from 'react';
import { theme } from '../../utility';

const actionButtonStyle = {
  background: theme.colors.black,
  borderRadius: 5,
  width: 26,
  height: 26,
  minWidth: 26,
  padding: 0,
  flexShrink: 0,
};

export function ColumnHeaderTooltip({ label, helpText }) {
  return (
    <span className="d-inline-flex align-items-center">
      {label}
      {helpText ? (
        <Tooltip title={helpText}>
          <Info size={14} className="ml-1" />
        </Tooltip>
      ) : null}
    </span>
  );
}

export function OrderRowActionsDropdown({ items, onAction }) {
  const menuItems = useMemo(
    () =>
      items.map(({ key, label, icon, disabled, danger }) => ({
        key,
        label,
        icon,
        disabled,
        danger,
      })),
    [items],
  );

  const handleMenuClick = useCallback(
    ({ key, domEvent }) => {
      domEvent.stopPropagation();
      onAction(String(key));
    },
    [onAction],
  );

  return (
    <Dropdown
      menu={{ items: menuItems, onClick: handleMenuClick }}
      placement="bottomRight"
      trigger={['hover', 'click']}
    >
      <Button
        type="text"
        icon={<DotsThree size={20} weight="bold" color={theme.colors.white} />}
        onClick={event => event.stopPropagation()}
        onMouseDown={event => event.stopPropagation()}
        style={actionButtonStyle}
      />
    </Dropdown>
  );
}
